import { useState } from "react";
import useEvent from '@react-hook/event';

export default function useMousedown() {
    const [mousedown, setMousedown] = useState(false);

    useEvent(document, 'mousedown', () => setMousedown(true));
    useEvent(document, 'mouseup', () => setMousedown(false));

    return mousedown;
}